import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B100140FindRequest = {
  tankaKbn: string;
} & Partial<{
  kikanymd: string;
  shohinCdFrom: string;
  shohinCdTo: string;
  shodaibunFrom: string;
  shodaibunTo: string;
  shochubunFrom: string;
  shochubunTo: string;
  shoshobunFrom: string;
  shoshobunTo: string;
}>;

export type B100140FindResponse = {
  shohinCd: string;
  shohinNm: string;
  kikanFromymd: string;
  tanka: string;
  genkatanka: string;
  tankaVersion: number;
  genkaVersion: number;
  tankaKbn: string;
};

export const B100140Find = (props: B100140FindRequest) => {
  return RestClient.get<B100140FindResponse[]>("b100140/find", {
    params: props,
  });
};

export type B100140CreateRequest = {
  tankaKbn: string;
  shohinCd: string;
  kikanFromymd: string;
  tanka: string;
} & Partial<{
  genkatanka: string;
}>;

export const B100140Create = (data: B100140CreateRequest) => {
  return RestClient.post("b100140/create", data);
};

export type B100140UpdateRequest = {
  tankaKbn: string;
  shohinCd: string;
  defaultKikanFromymd: string;
  kikanFromymd: string;
  tanka: string;
  tankaVersion: number;
} & Partial<{
  genkatanka: string;
  genkaVersion: number;
}>;

export const B100140Update = (data: B100140UpdateRequest) => {
  return RestClient.put("b100140/update", data);
};

export type B100140DeleteRequest = {
  tankaKbn: string;
  shohinCd: string;
  kikanFromymd: string;
};

export const B100140Delete = (data: B100140DeleteRequest) => {
  return RestClient.delete("b100140/delete", { data: data });
};

export type B100140GetRequest = {
  tankaKbn: number;
  shohinCd: string;
  kijunDate: string;
} & Partial<{}>;

export type B100140GetResponse = {
  tanka: string;
};

export const B100140Get = (props: B100140GetRequest) => {
  return RestClient.get<B100140GetResponse>("b100140/get/tanka", {
    params: props,
  });
};

/**
 * 上代単価取得メソッド
 * @param methods UseFormReturn
 * @param tankaKbn 単価マスタ.単価区分
 * @param kijunYmd 基準日
 * @param navigate Function
 * @param setMsg Function
 */
export const B100140Jodaitanka = async (
  methods: UseFormReturn,
  tankaKbn: number,
  kijunDate: string,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();

  if (typeof tankaKbn === "undefined" || fields.shohinCd === "" || !kijunDate) {
    methods.setValue("jodaitanka", "");
    return;
  }

  await B100140Get({
    tankaKbn: tankaKbn,
    shohinCd: fields.shohinCd,
    kijunDate: kijunDate,
  })
    .then((response) => {
      // 上代単価
      methods.setValue("jodaitanka", response.data.tanka ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("jodaitanka", "");
    });
};
